if (!customElements.get('delivery-counter')) {
  class DeliveryCounter extends HTMLElement {
    constructor() {
      super();
      let self = this;
      this.deliveryInterval = setInterval(function() {
        self.updateTimer();
      }, 1000);
    }

    updateTimer() {
      let self = this;
      if (window.deliverySchedule.length) {
        const now = new Date();
        const methods = [];

        // Determine the next shipment time
        let nextShipment = null;
        let lastShipment = null;
        window.deliverySchedule.forEach((s) => {
          let [hours, minutes] = s.time.split(':').map(Number);
          let today = now.getDay();
          // check if today is weekdays or sat or sun
          if (today === 0 && s.timeSun) {
            hours = s.timeSun.split(':').map(Number)[0];
            minutes = s.timeSun.split(':').map(Number)[1];
          }
          if (today === 6 && s.timeSat) {
            hours = s.timeSat.split(':').map(Number)[0];
            minutes = s.timeSat.split(':').map(Number)[1];
          }

          const shipmentTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
          if (shipmentTime > now) {
            methods.push(s.name);
            if (!nextShipment || shipmentTime < nextShipment) {
              nextShipment = shipmentTime;
            }
            if (!lastShipment || shipmentTime > lastShipment) {
              lastShipment = shipmentTime;
            }
          }
        });

        // Update the available methods
        const methodsElement = self.querySelector('.available-methods');
        if (methods.length && methodsElement) {
          methodsElement.textContent = `(${methods.join(', ')})`;
          self.classList.remove('hidden'); // FIX: remove hidden when active methods exist
        } else {
          clearInterval(this.deliveryInterval);
          if (self.querySelector('.delivery-counter-title-timeout')) {
            self.querySelector('.delivery-counter-title-timeout').classList.remove('hidden');
            if (self.querySelector('.delivery-counter-title')) {
              self.querySelector('.delivery-counter-title').classList.add('hidden');
            }
            self.querySelector('.timer-wrapper').classList.add('hidden');
          } else {
            self.classList.add('hidden');
          }
          return;
        }

        // Update the countdown timer
        if (nextShipment) {
          const diff = lastShipment - now;
          let hours = Math.floor(diff / 3600000);
          hours = hours < 10 ? '0' + hours : hours;
          let minutes = Math.floor((diff % 3600000) / 60000);
          minutes = minutes < 10 ? '0' + minutes : minutes;
          let seconds = Math.floor((diff % 60000) / 1000);
          seconds = seconds < 10 ? '0' + seconds : seconds;

          const timerElement = self.querySelector('.timer');
          timerElement.innerHTML = `<span class="timer-number">${hours} ${window.theme.strings.hourText}</span> <span class="timer-separate">|</span> <span class="timer-number">${minutes} ${window.theme.strings.minuteText}</span> <span class="timer-separate">|</span> <span class="timer-number">${seconds} ${window.theme.strings.secondText}</span>`;
        } else {
          const timerElement = self.querySelector('.timer');
          timerElement.innerHTML = '-';
        }
      }
    }

  }
  customElements.define('delivery-counter', DeliveryCounter);
}
